<template>
	<section v-observe-visibility="videoLaunch" :style="{'background-color':bgColor}" class="video_section"
	         v-bind:class="{video_section_boxed: isBoxed}">
		<div ref="video_section_simple" class="video_section_simple">
			<video v-if="isAutoplayed" ref="videoSimple" :src="videoPath(video)" autoplay loop muted
			       v-bind:class="{border_desktop: hasMask}" v-bind:poster="imgPath(poster)"></video>
			<video v-else ref="videoSimple" :src="videoPath(video)" controls="true" v-bind:class="{border_desktop: hasMask}"
			       v-bind:poster="imgPath(poster)"></video>
			<div v-if="legende" ref="legende" class="video_section_legende" v-html="legende"></div>
		</div>
	</section>

</template>

<script>

import Vue2Filters from "vue2-filters";
import Vue from "vue";
import VueObserveVisibility from "vue-observe-visibility";

Vue.use(VueObserveVisibility);

export default {
	name: "VideoSingle",
	mixins: [Vue2Filters.mixin],
	components: {},
	data: function () {
		return {
			isBoxed: (this.boxed),
			hasMask: (this.mask),
			isAutoplayed: (this.autoplay),
			isVisible: true
		};
	},
	props: {
		video: {
			type: String,
			default: ""
		},
		poster: {
			type: String,
			default: ""
		},
		boxed: {
			type: String,
			default: ""
		},
		mask: {
			type: String,
			default: ""
		},
		autoplay: {
			type: String,
			default: ""
		},
		legende: {
			type: String,
			default: ""
		},
		bgColor: {
			type: String,
			default: "transparent"
		}
	},
	methods: {
		videoPath: function (video) {
			return require("../assets/videos/" + video);
		},
		imgPath: function (image) {
			return require("../assets/images/" + image);
		},
		videoLaunch(isVisible, entry) {
			this.isVisible = isVisible;
			if (isVisible === true && this.autoplay == "true") {
				setTimeout(function () {
					entry.target.getElementsByTagName("video")[0].play();
				}, 500);
			} else {
				entry.target.getElementsByTagName("video")[0].pause();
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use '@/assets/scss/partials/variables' as *;
@use '@/assets/scss/partials/mixins' as *;


.video_section {
	overflow: hidden;

	video {
		width: 100%;
	}

	&_simple {
		position: relative;

		.video_section_legende {
			color: black;
			padding: $padding-simple 0;
			position: relative;
		}
	}

	&_boxed {
		padding: 5rem;
		text-align: center;
		@include breakpoint(lt-sm) {
			padding: 3.5rem;
		}

		video {
			margin: auto;
			max-width: 110rem;
		}
	}
}

</style>
